import React, {
  FC,
  useState,
  useCallback,
  useEffect,
  ChangeEvent,
  useMemo,
} from 'react';
import { observer } from 'mobx-react';
import {
  DialogActions,
  DialogContent,
  Divider,
  TextField,
  TextFieldProps,
} from '@mui/material';
import styled from 'styled-components';
import Dialog from 'components/UI/Dialog';
import Button from 'components/UI/Button';
import Input from 'components/UI/Input';
import Grid from 'components/UI/Grid';
import Text from 'components/UI/Text';
import { theme } from 'components/UI';
import { useTranslation } from 'react-i18next';
import { useStores } from 'stores/hooks/hooks';
import Space from 'components/UI/Space';
import { ActionMode, DialogOnCloseReason } from 'models/shared';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DropdownChangeEvent } from 'primereact/dropdown';
import Select from 'components/UI/Select';
import Loading from 'components/UI/Loading/Loading';
import { getAxiosErrorMessage } from 'utils/httpErrorsHelpers';
import i18next, { use } from 'i18next';

const StyledMultiSelect = styled(Select)``;

const NoWrappingText = styled(Text)`
  white-space: nowrap;
  min-width: 30%;
  max-width: 30%;
`;

interface GrowerManagementDialogProps {
  visible: boolean;
  onHide: () => void;
  title: string;
}

const ManualSendDialog: FC<GrowerManagementDialogProps> = observer(
  ({ visible, onHide, title }) => {
    const { t } = useTranslation('grower');
    const { resellersStore } = useStores();
    const [isLoading, setIsLoading] = useState(false);
    console.log('resellersStore', resellersStore.selectedGrowerId);
    const [selectedNotificationType, setSelectedNotificationType] =
      useState('');

    const notificationTypes = useMemo(() => ['1', '2', '3'], []);

    const [growerNameEdit, setGrowerNameEdit] = useState('manual_send');

    const [initialActionString, setInitialActionString] = useState('');
    useEffect(() => {
      if (initialActionString || growerNameEdit === '') {
        return;
      }

      setInitialActionString(growerNameEdit);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const closeDialog = useCallback(() => {
      setInitialActionString('');
      onHide();
    }, [onHide]);

    const handleCloseDialog = useCallback(
      (event: any, reason: DialogOnCloseReason) => {
        if (reason && reason === DialogOnCloseReason.BackDropClick) {
          return;
        }

        setGrowerNameEdit('');
        closeDialog();
      },
      [closeDialog],
    );

    const handleCloseButton = useCallback(() => {
      setGrowerNameEdit('');
      closeDialog();
    }, [closeDialog]);

    const handleChangeSelect = useCallback((event: DropdownChangeEvent) => {
      const { value } = event;
      setSelectedNotificationType(value);
    }, []);

    const handleSubmitClick = async () => {
      try {
        // send notification
        await resellersStore.sendWhatsAppNotification(
          resellersStore.selectedGrowerId,
        );

        resellersStore.successToast(
          i18next.t('Notification sent successfully'),
        );
      } catch (error) {
        resellersStore.errorToast(
          getAxiosErrorMessage(error) ??
          i18next.t('errors:something_went_wrong'),
        );
      }

      closeDialog();
    };

    useEffect(() => {
      if (visible) {
        // get Data
      }
    }, [visible]);

    return (
      <Dialog
        open={visible}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm"
        dialogTitle={title}
        titleWeight="bold"
        disableEscapeKeyDown
      >
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Space height={1} />
            <Grid direction="column" gap="10px">
              {isLoading ? (
                <Loading />
              ) : (
                <Grid
                  direction="row"
                  gap="10px"
                  alignSelf="start"
                  grow
                  justify="start"
                >
                  <NoWrappingText>{t('notification_type')}:</NoWrappingText>
                  <StyledMultiSelect
                    id="system-type"
                    options={notificationTypes}
                    value={selectedNotificationType}
                    onChange={handleChangeSelect}
                  />
                </Grid>
              )}
            </Grid>
            <Space height={1} />
          </LocalizationProvider>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={handleSubmitClick}
            disabled={!selectedNotificationType}
          >
            <Text textcolor={theme.color.white} size="sm">
              {t('send')}
            </Text>
          </Button>
          <Button onClick={handleCloseButton}>
            <Text textcolor={theme.color.white} size="sm">
              {t('cancel')}
            </Text>
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default ManualSendDialog;
